import React, { useEffect, useState } from 'react';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import useWizardLoading from '@swf/core/hooks/useWizardLoading';

import { CardType } from '../../types/cardType';
import Prompt from '../Prompt/Prompt';

import { TXTWCL_Your_request_is_being_processe_ELL } from './TransactionLoader.messages.json';
import { title } from './TransactionLoader.scss';
import TransactionLoadingSVG from './TransactionLoadingSVG';
import CompletedAnimation from './transaction-completed.svg';

export const animationLoadingDelay = 6000;

const TransactionLoader: React.FC = () => {
  const { loading, service } = useWizardLoading();
  const {
    data: { depositResult },
    values: { deposit: { type } = {} },
    error
  } = useWizardContext();

  const [loaderVisible, setLoaderVisible] = useState(false);
  const transactionInProgress = !!depositResult?.status;
  const isDepositProcess = service?.includes('deposit.deposit-process');
  const [changeAnimation, setChangeAnimation] = useState(false);

  useEffect(() => {
    if (
      loading &&
      isDepositProcess &&
      !loaderVisible &&
      !transactionInProgress &&
      !error &&
      type &&
      ![CardType.ApplePay, CardType.GooglePay].includes(type)
    ) {
      setLoaderVisible(true);
    }
  }, [loading, isDepositProcess, loaderVisible, transactionInProgress, error, type]);

  useEffect(() => {
    error && loaderVisible && setLoaderVisible(false);
  }, [error, loaderVisible]);

  useEffect(() => {
    const timeout =
      !loading && loaderVisible
        ? setTimeout(() => {
            setLoaderVisible(false);
          }, animationLoadingDelay)
        : null;

    return () => {
      timeout && window.clearTimeout(timeout);
    };
  }, [loading, loaderVisible]);

  if (!loaderVisible) {
    return null;
  }

  return (
    <Prompt
      title={{ translation: TXTWCL_Your_request_is_being_processe_ELL }}
      classes={{ title }}
      noCloseButton
      variant="loading"
    >
      {changeAnimation ? (
        <CompletedAnimation />
      ) : (
        <TransactionLoadingSVG changeAnimation={setChangeAnimation} loading={loading} />
      )}
    </Prompt>
  );
};

export default TransactionLoader;
